// Sales review in the shared year-end workflow.
window.PlummeI18n.register('en', {
  'route.arsavslutning-salg': 'Sales',
  'clo.sales.title': 'Sales',
  'clo.sales.openReview': 'View sales review',
  'clo.sales.year': 'Income year {{year}}',
  'clo.sales.subtitle': 'Automatic check for drafts and missing information in sales documents for {{year}}.',
  'clo.sales.pending': '{{count}} sales documents need processing before the sales check for {{year}} is ready.',
  'clo.sales.ready': 'The document check for {{year}} is complete automatically. No drafts or missing information found.',
  'clo.sales.followUp': 'Sales documents for {{year}} have passed the posting check. {{followUps}} deliveries need follow-up.',
  'clo.sales.unsupported': 'The sales check does not support this country, framework or year.',
  'clo.sales.issuesTitle': 'Drafts and missing information',
  'clo.sales.noIssues': 'No drafts or incomplete sales documents found in this check.',
  'clo.sales.draft': 'Complete the draft or remove it if the sale will not take place.',
  'clo.sales.undated': 'Missing a valid document date. Establish which year the sale belongs to.',
  'clo.sales.incomplete': 'Incomplete document. Check its number, lines and description.',
  'clo.sales.unknownDate': 'Year needs clarification',
  'clo.sales.followUpsTitle': 'Follow up delivery',
  'clo.sales.unsent': 'No delivery recorded in Plumme',
  'clo.sales.deliveryFailed': 'The latest email failed or was rejected',
  'clo.sales.sendingHelp': 'Check that the customer received the document. Delivery is separate from posting: documents may be delivered outside Plumme, and email status does not establish when revenue was earned.',
  'clo.sales.receivablesTitle': 'Open customer items at 31 December {{year}}',
  'clo.sales.receivablesHelp': 'Shows Plumme invoices and credit notes open at year-end, including earlier years. Later payments do not change the year-end amount. This is not a complete reconciliation of account 1500 or imported history.',
  'clo.sales.settledAfter': 'Settled after year-end: {{amount}}',
  'clo.sales.noReceivables': 'No open customer items found in this source at year-end.',
  'clo.sales.otherSalesTitle': 'Other posted sales',
  'clo.sales.invoiceListTitle': 'Invoice list',
  'clo.sales.approveWithoutChanges': 'Approve without changes',
  'clo.sales.otherSale': 'Other sale',
  'clo.sales.invoice': 'Invoice',
  'clo.sales.credit': 'Credit note',
  'clo.sales.openDocument': 'Open document',
  'clo.sales.openList': 'Open invoice list',
  'clo.sales.scopeHelp': 'Document dates determine the sales shown. Undated documents need clarification; creation timestamps do not assign a sales date. Offers and order confirmations are not automatically earned revenue. Cut-off, unbilled sales, losses, currency and full reconciliation have separate checks.',
  'clo.sales.back': 'Back to sales review',
  'clo.sales.backToClosing': 'Back to year-end closing',
  'clo.sales.loadError': 'Could not open the sales workspace.',
  'clo.sales.documentGone': 'The document is no longer in the invoice list. Return to refresh the review.',
});
